// src/widgets/widgets/QuickStats.tsx
import { useMemo } from 'react';
import { Paper, Text, Group, Stack, ThemeIcon, SimpleGrid } from '@mantine/core';
import { IconReceipt, IconCheck, IconClock, IconCash } from '@tabler/icons-react';
import type { WidgetProps } from '../types';

function QuickStats({ bills }: WidgetProps) {
	const stats = useMemo(() => {
		const totalBills = bills.length;
		const paidBills = bills.filter((b) => b.paid).length;
		const unpaidBills = totalBills - paidBills;
		const totalOwed = bills
			.filter((b) => !b.paid)
			.reduce((sum, b) => sum + b.amount, 0);

		return { totalBills, paidBills, unpaidBills, totalOwed };
	}, [bills]);

	const items = [
		{
			label: 'Total Bills',
			value: stats.totalBills,
			icon: IconReceipt,
			color: 'blue',
		},
		{
			label: 'Paid',
			value: stats.paidBills,
			icon: IconCheck,
			color: 'green',
		},
		{
			label: 'Unpaid',
			value: stats.unpaidBills,
			icon: IconClock,
			color: 'orange',
		},
		{
			label: 'Total Owed',
			value: `$${stats.totalOwed.toFixed(2)}`,
			icon: IconCash,
			color: 'grape',
		},
	];

	return (
		<Paper withBorder p='md' radius='md'>
			<Text fw={600} mb='md'>
				Quick Stats
			</Text>
			<SimpleGrid cols={2} spacing='sm'>
				{items.map((item) => (
					<Group key={item.label} gap='xs'>
						<ThemeIcon
							size='md'
							radius='md'
							variant='light'
							color={item.color}
						>
							<item.icon size={16} />
						</ThemeIcon>
						<Stack gap={0}>
							<Text size='xs' c='dimmed'>
								{item.label}
							</Text>
							<Text fw={600} size='sm'>
								{item.value}
							</Text>
						</Stack>
					</Group>
				))}
			</SimpleGrid>
		</Paper>
	);
}

export default QuickStats;
